import { render, staticRenderFns } from "./ArticleRelocator.vue?vue&type=template&id=613b0304"
import script from "./ArticleRelocator.vue?vue&type=script&lang=js"
export * from "./ArticleRelocator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports